import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import css from './css.less';
import { Form } from 'src/components/RcForm';
import { get } from 'lodash';
import { validateSeoSetting } from './validator';
//import { useDebounce } from 'src/tools/customHooks';

const ErrorDisplay = (props) => {
  const v = Form.useWatch([], props.form);
  const savedData = props.data;

  const res = validateSeoSetting(props.selected ? v : savedData);
  const hasError = get(res, 'hasError');

  return hasError ? <InfoCircleFilled rev className={css.iconWarn} /> : null;
};
export default ErrorDisplay;
